import PropTypes from 'prop-types';
import React from 'react';
import Callout from '../../shared/components/Callout';
import RuleCard from './RuleCard';
import { BLOCK_LIST_COPY } from '../constants/automationRules';

// The warning is a `footer`, not `children`, so it renders in BOTH states. The off state is
// the one that most needs saying: turning the rule off stops new blocks and lifts nothing,
// which is the opposite of what most people assume they just did.
//
// block_list_on_refund is ungated (FinanceAutomationRule::UNGATED_RULE_TYPES) and defaults
// on, so this card is live for every team regardless of the rollout flag.
const BlockListRule = ({ rule, busy, canAdminister, onToggle }) => (
  <RuleCard
    ruleType={BLOCK_LIST_COPY.ruleType}
    title={BLOCK_LIST_COPY.title}
    icon={BLOCK_LIST_COPY.icon}
    description={BLOCK_LIST_COPY.description}
    enabled={rule.enabled}
    busy={busy}
    canAdminister={canAdminister}
    onToggle={onToggle}
    footer={
      <Callout
        tone="warning"
        lead={rule.enabled ? BLOCK_LIST_COPY.onLead : BLOCK_LIST_COPY.offLead}
        testId="block-list-warning"
      >
        {rule.enabled ? BLOCK_LIST_COPY.onBody : BLOCK_LIST_COPY.offBody}
      </Callout>
    }
  />
);

BlockListRule.propTypes = {
  rule: PropTypes.shape({ enabled: PropTypes.bool }).isRequired,
  busy: PropTypes.bool,
  canAdminister: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

BlockListRule.defaultProps = { busy: false, canAdminister: false };

export default BlockListRule;
